import { AsyncPipe, NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { select, Store } from '@ngrx/store';
import moment from 'moment';
import { Observable } from 'rxjs';
import { Group } from '../../../../models/group.model';
import { Prayer } from '../../../../models/prayer.model';
import { MemberService } from '../../../../services/member.service';
import * as prayerActions from '../../../../state/actions/prayer.actions';
import { AppState } from '../../../../state/appstate';
import * as groupSelector from '../../../../state/selectors/group.selector';
import { BtnBackComponent } from '../../../components/buttons/btn-back/btn-back.component';
import { LoadingDotsComponent } from '../../../components/spinners/loading-dots/loading-dots.component';

@Component({
  selector: 'app-create-prayer',
  standalone: true,
  templateUrl: './create-prayer.component.html',
  styleUrls: ['./create-prayer.component.css'],
  imports: [
    NgIf,
    AsyncPipe,
    BtnBackComponent,
    ReactiveFormsModule,
    RouterLink,
    LoadingDotsComponent,
  ],
})
export class CreatePrayerComponent {
  route: ActivatedRoute = inject(ActivatedRoute);

  pageForm: FormGroup;

  today: Date = new Date();
  moment = moment;

  groupId: string | null = this.route.snapshot.paramMap.get('id');
  group$: Observable<Group | null | undefined>;

  working: boolean = false;

  private searchText: string | undefined;
  searchTerm: string | undefined;
  members: any = [];

  constructor(
    private store: Store<AppState>,
    private memberService: MemberService,
  ) {
    this.pageForm = new FormGroup({
      subject: new FormControl('', [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(100),
      ]),
      description: new FormControl('', [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(500),
      ]),
      category: new FormControl('', Validators.required),
      requestedBy: new FormControl(''),
      requestedById: new FormControl(''),
      expiry: new FormControl(
        moment().add(30, 'days').format('YYYY-MM-DD'),
        Validators.required,
      ),
    });

    this.group$ = this.store.pipe(
      select(groupSelector.getGroupById(this.groupId!)),
    );
  }

  search(event: any) {
    this.searchText = event.target.value;
  }

  isSearching: boolean = false;
  searchMembers() {
    if (!this.searchText) {
      return;
    }
    this.isSearching = true;
    this.memberService
      .searchMembers(this.searchText, this.groupId!)
      .then((result) => {
        if (result?.data?.length === 0) {
          this.pageForm.get('requestedBy')?.setErrors({ notFound: true });
          this.members = [];
        } else {
          this.members = result?.data;
        }
        this.isSearching = false;
      })
      .catch((error: any) => {
        console.error('Error searching members', error);
        this.isSearching = false;
        this.members = [];
        this.pageForm.get('requestedBy')?.setErrors({ searchFailed: true });
      });
  }

  trackById(index: number, item: any): void {
    return item.id;
  }

  setMember(member: any) {
    this.pageForm.get('requestedBy')?.setValue(member.name);
    this.pageForm.get('requestedById')?.setValue(member.memberId);
    this.members = [];
    // console.log(`RequestedBy: ${member.name} (${member.memberId})`);
  }

  setCategory(item: string) {
    this.pageForm.get('category')?.setValue(item);
  }

  create() {
    if (this.pageForm.invalid) {
      return;
    }

    const temp: Prayer = {
      ...this.pageForm.value,
      expiry: moment(this.pageForm.get('expiry')?.value)
        .startOf('day')
        .toDate(),
      groupId: this.groupId!,
    };

    this.store.dispatch(prayerActions.create({ prayer: temp }));
  }
}
